import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { ApplicantEntityIndex } from '@funnels/types';

import { TextInputField } from '../../../Fields';

interface CityOfBirthProps extends ApplicantEntityIndex {
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const CityOfBirth = ({ applicantIndex, isOptional, isDisabled }: CityOfBirthProps) => (
  <TextInputField
    label="City of birth"
    name={FIELD_PATHS.APPLICANT_CITY_OF_BIRTH(applicantIndex)}
    isOptional={isOptional}
    isDisabled={isDisabled}
    className={PII_FIELD_MASKING_CLASS}
  />
);
